import { OrbitalTrackFilterData } from '@apeiron/orbital'
import { StarTier } from '@apeiron/star'
import {
  clipFilterSchema,
  slideFilterSchema
} from '@src/deserialize/yup/filter'
import { tierSchema } from '@src/deserialize/yup/starFilter'
import * as yup from 'yup'

// used on "orbit_filters.json"
export const orbitalTrackFilterDataSchema: yup.SchemaOf<OrbitalTrackFilterData> =
  yup
    .object({
      orbitFilterCost: yup.array().of(slideFilterSchema).default([]),
      orbitFilterEffect: yup.array().of(slideFilterSchema).default([]),
      orbitFilterTier: clipFilterSchema<StarTier>(tierSchema)
    })
    .camelCase()
    .noUnknown(true)
